export default __webpack_public_path__ + "static/media/Enlarge.6621f8d4.svg";